import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { OnboardService } from '../../../Menus/Onboard/onboard.service';
import { VisualsService } from '../visuals.service';

@Component({
  selector: 'formly-field-ng-select',
  providers: [OnboardService],
  template: `
    <ng-select  [items]="to.options | sort:labelProp"
      class="customSelect"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [virtualScroll]="true"
      [loading]="loading"
      [placeholder]="to.placeholder"
      [formControl]="formControl"
      (open)="opened(to.dependency)"
      [formlyAttributes]="field">
      <ng-template ng-option-tmp let-item="item" *ngIf="to?.tooltip">
      <div [tooltip]="item.text+' : '+tool(item.id)">{{ item.text }}</div>
      </ng-template>
    </ng-select>
  `,
})
export class FormlyFieldSelect extends FieldType {
  loading = false;

  constructor(
    public service: OnboardService,
    public visualsService: VisualsService,
  ) {
    super();
  }

  ngOnInit() {
    this.fetchOptions(this.to.dependency);
  }

  

  get labelProp(): string { 
    return this.to.labelProp ||  'text' }
  get valueProp(): string { 
    return this.to.valueProp || 'id' }
  
     tool(value){
      return  this.to.tooltip.find((x) => x.id == value).text
    }

  
  opened(dependency) {
    this.fetchOptions(dependency);
  }

  private fetchOptions(dependency: any) {
    if (dependency && dependency.dependentService) {
      this.loading = true;
      this.props.options = [];
      let dependentKeyVal = dependency.dependentKey && this.model[dependency.dependentKey]
        ? this.model[dependency.dependentKey]
        : '';
      this.service[dependency.dependentService](dependentKeyVal).subscribe({
        next: (data) => {
          let resp = data.data;
          var result = resp.map((el) => ({
            id: el.id,
            text: el.text,
          }));
          this.props.options = result;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
    }
  }
}